import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'
import styles from '../styles'
import ChatDummy from '../../ChatDummy/ChatDummy'

const ChatMessagesListView = ({ children, classes }) => {
  const messagesEndRef = useRef(null)

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView()
  }

  useEffect(scrollToBottom)

  return (
    <section className={classes.wrapper}>
      <div style={{ marginTop: 'auto' }} />
      {children.length > 0 ? children : <ChatDummy />}
      <div id="messagesEndRef" ref={messagesEndRef} />
    </section>
  )
}

ChatMessagesListView.propTypes = {
  classes: PropTypes.object,
}

export default injectStyles(styles)(ChatMessagesListView)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMessagesList/component/ChatMessagesListView.js